export default import.meta.ROLLDOWN_FILE_URL_cn7IAAGY294pWGc7MpElVg_313fad75c039a3e0331a7d75